import { designChangeIds } from "./changes";

// Read once at load so the choice survives client-side navigation inside a review iframe.
// ?dr=none → all changes off, ?dr=a,b → only those on, no param → all on.
function readEnabled(): Set<string> {
  if (typeof window === "undefined") return new Set(designChangeIds);
  const param = new URLSearchParams(window.location.search).get("dr");
  if (param === null || param === "all") return new Set(designChangeIds);
  if (param === "none") return new Set();
  return new Set(param.split(","));
}

const enabled = readEnabled();

export function isDesignChangeOn(id: string): boolean {
  return enabled.has(id);
}

export function useDesignChange(id: string): boolean {
  return enabled.has(id);
}
